import { useEffect } from "react";
import { handleFontSizeChange } from "./handle-set-font-size-change";
import { GameName, gameSettings } from "inbox-contentful";

export const useSetBaseFontSizeEffect = (fixedFontSize?: string) => {
    const referenceWidth =
        gameSettings[window.GAMENAME as GameName].referenceWidth;

    useEffect(() => {
        const handler = handleFontSizeChange(referenceWidth, fixedFontSize);

        setTimeout(handler, 0);

        window.addEventListener("resize", handler);

        const timeout = setInterval(() => {
            handler();
        }, 250);

        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", handler);
        };
    }, []);
};
